import axios from "axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import type {
  CalculateTradeExpenseFromTemplateResult,
  iTradeExpense,
} from "./trade-expenses-models";

export class TradeExpensesServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.tradeExpenses.configure(config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.tradeExpenses.configure(config);
  }

  tradeExpenses = new EntityServices<iTradeExpense>(SDKConfig, "trade-expenses", {});

  validateCostFormulae = async (body: { costFormulae: string }) => {
    const results = await axios.post<{
      valid: boolean;
      value?: number;
      error?: string;
    }>(this.config.basePath + `/trade-expenses/validate-cost-formulae`, body, {
      headers: { Authorization: this.config.token },
    });
    return results.data;
  };

  calculateFromTemplate = async (body: {
    brandId: string;
    templateId: string;
    year: number;
    month: number;
  }) => {
    const results = await axios.post<CalculateTradeExpenseFromTemplateResult>(
      this.config.basePath + `/trade-expenses/calculate-from-template`,
      body,
      { headers: { Authorization: this.config.token } }
    );
    return results.data;
  };
}
